var SharedModalModule = /** @class */ (function () {
    function SharedModalModule() {
    }
    return SharedModalModule;
}());
export { SharedModalModule };
